module.exports = __webpack_public_path__ + "static/img/goodsList.50303ed1.png";